import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Card, Col, Row, Button, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import moment from 'moment';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import axios from "axios";
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const DrugsAdminModal = ({ show, setShow, patientid, patientname, drugsdata }) => {

    const [showNotesModal, setShowNotesModal] = useState(false);
    const [notesContent, setNotesContent] = useState('');
    const [patientId, setPatientId] = useState("");
    const [drugs, setDrugsData] = useState([]);
    const [tableOpData, setTableOpData] = useState([]);
    const changeTypeMaster = {
        0: '-',
        1: 'DC',
        2: 'Label Change',
        3: 'Hold'
      };

    const columns = React.useMemo(() =>
        [
            // {
            //     accessorKey: 'patient',
            //     header: 'Patient',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start' },
            //         cellProps: { className: 'text-start' }
            //     }
            // },
            {
                accessorKey: 'rxnumber',
                header: 'Rx number',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start px-2' }
                }
            },
            {
                accessorKey: 'drug',
                header: 'Drug',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start px-2' }
                }
            },
            // {
            //     accessorKey: 'type',
            //     header: 'Type',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start px-2' },
            //         cellProps: { className: 'text-start px-2' }
            //     }
            // },
            // {
            //     accessorKey: 'document',
            //     header: 'Document',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start px-2' },
            //         cellProps: { className: 'text-start w-25 px-2' }
            //     }
            // },
            // {
            //     accessorKey: 'details',
            //     header: 'Details',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start w-25 px-2' },
            //         cellProps: { className: 'text-start px-2' }
            //     }
            // },
            {
                accessorKey: 'changeType',
                header: 'Change Type',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'px-2' }
                },
                cell: ({ row: { original } }) => {
                    const displayText = changeTypeMaster[original?.changeType] || '-';

                    const handleOpenDocumentOrNotes = (original) => {
                        const content = original.document || original.notes;
                        if (content) {
                          if (content.startsWith('http')) {
                            window.open(content, '_blank');
                          } else {
                            setNotesContent(content);
                            setShowNotesModal(true);
                          }
                        } else {
                          toast.info('No Document or Notes available.');
                        }
                      };
                    return (
                        <span
                            style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleOpenDocumentOrNotes(original)}
                        >
                            {displayText}
                        </span>
                    );
                }
            },
            {
                accessorKey: 'facility',
                header: 'Facility',
                meta: {
                    headerProps: { className: 'text-900 text-center' },
                    cellProps: { className: 'text-center' }
                }
            },
            {
                accessorKey: 'program',
                header: 'Program',
                meta: {
                    headerProps: { className: 'text-900 text-center' },
                    cellProps: { className: 'text-center' }
                }
            },
            {
                accessorKey: 'loa',
                header: 'Loa',
                meta: {
                    headerProps: { className: 'text-900 text-center' },
                    cellProps: { className: 'text-center' }
                }
            },            
            {
                accessorKey: 'done_in_ips',
                header: 'Done in ips',
                meta: {
                    headerProps: { className: 'text-900 text-start w-25 px-2' },
                    cellProps: { className: 'text-start px-2' }
                },
                cell: ({ row: { original } }) => {
                    return <>
                        <Col className="mt-2">
                            <Form.Check
                                type='switch'
                                name={"ips" + original.index}
                                id={"is_yes" + original.index}
                                label='Done in IPS'
                                defaultChecked={!!original.done_in_ips}
                                onChange={(e) => {
                                    const value = e.target.checked ? 1 : 0;
                                    handleRowData(value, original.counter);
                                }}
                                // onChange={(e) => { handleRowData(e.target.value, original.counter) }}
                            />
                        </Col>
                    </>
                }
            }

        ], []
    );

    useEffect(() => {
        setPatientId(patientid)
        filterDrugsData(drugsdata);

    }, [patientid, patientname, drugsdata]);

    const handleRowData = (gridControlValue, gridControlIndex) => {
        let tempArrData = JSON.parse(localStorage.getItem("drugmodaladminresults"));//tableOpData; 

        //console.log("tableOpData ip" + JSON.stringify(tempArrData));

        tempArrData.forEach(function (arrayItem, index) {
            if (index == gridControlIndex) {
                console.log("index");
                arrayItem["done_in_ips"] = gridControlValue;
            }
        });

        //setTableOpData(tempArrData);
        localStorage.setItem("drugmodaladminresults", JSON.stringify(tempArrData));

        //console.log("tableOpData Op" + localStorage.getItem("drugmodalresults"));

    }

    async function filterDrugsData(drugsdata) {

        let results = [];
        let index = 0;
        let matchDetailParts = (detailsStr) => {
            const result = { facility: 0, program: 0, loa: 0 };
            if (detailsStr) {
                const matches = detailsStr.match(/Facility:(\d+),Program:(\d+),Loa:(\d+)/);
                if (matches) {
                    result.facility = parseInt(matches[1], 10);
                    result.program = parseInt(matches[2], 10);
                    result.loa = parseInt(matches[3], 10);
                }
            }
            return result;
        };

        for (let singledrugs_index in drugsdata) {
            const parsedDetails = matchDetailParts(drugsdata[singledrugs_index].details);
            results.push({
                cycledetailid: drugsdata[singledrugs_index].drugid,
                patient: drugsdata[singledrugs_index].patientname,
                rxnumber: drugsdata[singledrugs_index].rxnumber,
                drug: drugsdata[singledrugs_index].drug,
                type: drugsdata[singledrugs_index].type,
                document: drugsdata[singledrugs_index].document,
                notes: drugsdata[singledrugs_index].change_note,
                details: drugsdata[singledrugs_index].details,
                done_in_ips: drugsdata[singledrugs_index].done_in_ips,
                counter: index++,
                changeType : drugsdata[singledrugs_index].change_type,
                facility: parsedDetails.facility,
                program: parsedDetails.program,
                loa: parsedDetails.loa
            })

        }

        //const tempResults = results;
        //setTableOpData(tempResults);
        localStorage.setItem("drugmodaladminresults", JSON.stringify(results));
        setDrugsData(results);
    }


    const handleSave = async (e) => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let drugsGridUrl = `${process.env.REACT_APP_SERVER_URL}/cycles/update-cycle-prescriptions`;

        let presOpData = JSON.parse(localStorage.getItem("drugmodaladminresults"));

        console.log("columns" + tableOpData);

        let drugsGridData = []

        presOpData.forEach(function (arrayItem, index) {
            let singlerowitem =
            {
                "cycle_detail_id": arrayItem["cycledetailid"],
                "updated_in_ips": arrayItem["done_in_ips"]
            }
            drugsGridData.push(singlerowitem);
        });

        let finalDrugsData = {
            "cycle_patient_id": patientId,
            "prescriptions": drugsGridData
        }

        const { data } = await axios.post(drugsGridUrl, finalDrugsData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (Object.keys(data).length > 0) {
            toast.success("Drug Details added successfully");
            setShow(false);
        }
        else {
            toast.error("Error occured while filling Drug Details ");
        }
    }

    const table = useAdvanceTable({
        data: drugs,
        columns,
        selection: false,
        sortable: true,
        pagination: true,
        selectionColumnWidth: 52
    });

    return (
        <>
            <Modal show={showNotesModal} onHide={() => setShowNotesModal(false)} centered size="md">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fs-5 fw-semibold text-primary">
                        📝 Notes
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body
                    className="px-4 py-3"
                    style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        fontSize: '15px',
                        lineHeight: '1.6',

                        borderRadius: '0.5rem',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {notesContent || (
                        <div className="text-center text-muted py-5">
                            No notes available.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <Button variant="secondary" onClick={() => setShowNotesModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h5" id="copyLinkModalLabel">
                        Census For  {patientname}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-body-tertiary">
                    <Row>
                        <AdvanceTableProvider {...table}>
                            <Row>
                                <Col xs="12">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-10 mb-0 overflow-hidden'
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="p-4">
                                <Col>
                                    <AdvanceTableFooter
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                                    />
                                </Col>
                            </Row>
                        </AdvanceTableProvider>
                    </Row>
                    <br />
                    <Row>
                        <Col xs="8"></Col>
                        <Col xs="4">
                            <Button color="primary" className="w-100" onClick={handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

DrugsAdminModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired
};

export default DrugsAdminModal;

